import { useState } from "react";
import { OPS, fmtDT } from "@/lib/constants";
import { PageHeader } from "@/components/Common";
import { CrudPage } from "@/components/CrudPage";
import { StatusBadge } from "@/components/Badges";

const FIELDS = [
  { key: "hotel_id", label: "Struttura", type: "hotel", required: true },
  { key: "type", label: "Tipo", type: "select", required: true, options: [{ value: "incidente", label: "Incidente" }, { value: "near_miss", label: "Near miss (quasi incidente)" }] },
  { key: "category", label: "Categoria", type: "select", required: true, options: ["Furto", "Allarme incendio", "Intrusione", "Persona molesta", "Primo soccorso", "Danneggiamento", "Allarme tecnologico", "Altro"] },
  { key: "severity", label: "Gravità", type: "select", options: ["bassa", "media", "alta"], required: true },
  { key: "occurred_at", label: "Data/ora evento", type: "datetime", required: true },
  { key: "location", label: "Luogo", required: true },
  { key: "description", label: "Descrizione", type: "textarea", required: true },
  { key: "actions_taken", label: "Azioni intraprese / escalation", type: "textarea" },
  { key: "authorities", label: "Forze dell'Ordine allertate", type: "select", options: [{ value: "si", label: "Sì" }, { value: "no", label: "No" }] },
  { key: "status", label: "Stato", type: "select", options: ["aperto", "in analisi", "chiuso"], required: true },
];
const COLS = [
  { key: "occurred_at", label: "Evento", render: (r) => <span className="font-mono text-xs">{fmtDT(r.occurred_at || r.created_at)}</span> },
  { key: "type", label: "Tipo", render: (r) => <StatusBadge value={r.type} /> },
  { key: "category", label: "Categoria" },
  { key: "severity", label: "Gravità", render: (r) => <StatusBadge value={r.severity} /> },
  { key: "location", label: "Luogo" },
  { key: "description", label: "Descrizione", render: (r) => <span className="line-clamp-2 max-w-xs block">{r.description}</span> },
  { key: "status", label: "Stato", render: (r) => <StatusBadge value={r.status} /> },
];

export default function Incidenti() {
  const [type, setType] = useState("all");
  return (
    <>
      <PageHeader eyebrow="Registro anomalie" title="Incidenti & Near miss" subtitle="Classificazione, escalation e analisi degli eventi per il miglioramento continuo.">
        {[["all", "Tutti"], ["incidente", "Incidenti"], ["near_miss", "Near miss"]].map(([v, l]) => (
          <button key={v} onClick={() => setType(v)} data-testid={`incidents-filter-${v}`}
            className={`px-3 py-1.5 rounded-full text-xs border transition-colors ${type === v ? "bg-amber-600 text-white border-amber-500" : "border-slate-300 text-slate-500 hover:border-slate-400"}`}>{l}</button>
        ))}
      </PageHeader>
      <CrudPage resource="incidents" title="Segnalazione" testid="incidents" fields={FIELDS} columns={COLS} writeRoles={OPS} newLabel="Nuova segnalazione"
        params={type === "all" ? {} : { type }} defaults={{ status: "aperto", severity: "media", authorities: "no", type: "incidente" }}
        rowClass={(r) => (r.severity === "alta" && r.status !== "chiuso" ? "bg-red-50/70" : "")} />
    </>
  );
}
